import { t } from '@sm/intl';
import COPY from '~pricing/lib/packageFeatures/details/categoryCopy';

export default [
  {
    category: t(COPY.SURVEY_CAPABILITIES),
    features: [
      'survey_create_limit',
      'create_question_limit',
      'base_response_count',
      'web_social_email_responses',
      'collector_create_limit',
      'pop_up_collector',
      'track_email_responses',
      'mobile_apps_ios_android',
      'recurring_surveys',
      'payment_qt',
      'kiosk_mode_inactivity_timer',
      'kiosk_mode_passcode_lock',
    ],
  },
  {
    category: t(COPY.TEAM_COLLABORATION),
    features: [
      'add_users',
      'build_surveys_together',
      'analyze_results_together',
      'custom_templates',
      'team_themes',
      'shared_library',
    ],
  },
  {
    category: t(COPY.FAST_SUPPORT),
    features: ['email_support', 'priority_email_support', 'phone_support'],
  },
  {
    category: t(COPY.TEAM_MANAGMENT),
    features: ['team_ownership', 'user_management', 'consolidated_billing'],
  },
  {
    category: t(COPY.SURVEY_BUILDER),
    features: [
      'essential_question_types',
      'all_languages_supported',
      'pagination',
      'labeling_titles_numbering',
      'create_templates_enabled',
      'question_library',
      '508_accessibility',
      'matrix_question_type',
      'collect_contact_information',
      'video_question_type',
      'rating_question_type',
      'quiz_scoring_and_instant_results',
      'quizzes_pro',
      'create_skip_logic_enabled',
      'menu_matrix_enabled',
      'file_upload',
      'create_randomization_enabled',
      'a_b_testing',
      'create_quotas_enabled',
      'advanced_logic',
      'click_map_qt',
      'multilingual',
      'multiple_block_rotation_enabled',
    ],
  },
  {
    category: t(COPY.CUSTOMIZATION_BRANDING),
    features: [
      'progress_bar',
      'text_formatting',
      'create_logo_enabled',
      'create_custom_theme_enabled',
      'premium_themes',
      'collector_friendly_url_enabled',
      'collector_thank_you_enabled',
      'customize_disqualification_page_enabled',
      'create_custom_html_email_message_enabled',
      'create_piping_enabled',
      'carry_forward',
      'create_custom_variables_enabled',
      'create_toggle_footer_enabled',
      'collector_completion_url_enabled',
      'collector_white_label_enabled',
    ],
  },
  {
    category: t(COPY.ANALYSIS_REPORTING),
    features: [
      'real_time_results',
      'share_surveys',
      'analyze_trends_enabled',
      'response_quality_enabled',
      'plans_benchmarks',
      'benchmarks',
      'analyze_combine_filters',
      'analyze_can_customize_charts',
      'create_print_enabled',
      'analyze_export_enabled',
      'download_as_ppt',
      'analyze_ta_enabled',
      'analyze_can_ta_tag',
      'show_create_crosstab',
      'show_sig_diffs_enabled',
      'analyze_export_spss_enabled',
    ],
  },
  {
    category: t(COPY.RESPONSE_MANAGEMENT),
    features: [
      'require_answer',
      'validate_answer',
      'randomize_answer_choices',
      'set_survey_end_date',
      'view_respondent_ip_address',
      'record_respondent_email_address',
      'set_max_response_count',
      'respondent_receipt',
    ],
  },
  {
    category: t(COPY.ENHANCED_SECURITY),
    features: ['password_protection', 'enable_ip_blocking'],
  },
  {
    category: t(COPY.PARTNER_INTEGRATIONS),
    features: [
      'send_surveys',
      'collector_mobile_sdk_enabled',
      'mobile_sdk_pull_response_data_enabled',
      'extract_data',
      'private_apps',
    ],
  },
];
